module.exports = __webpack_public_path__ + "img/img_body_biz_gwangju_logo.6fea13cc.png";